import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-white text-gray-900 font-['Inter',sans-serif]">
      <Navbar />

      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gradient-to-br from-blue-50 via-white to-purple-50">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center">
            <div className="mb-4 text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600 text-xs uppercase tracking-[0.2em] font-semibold">
              Legal
            </div>
            <h1 className="text-5xl md:text-6xl font-extrabold text-gray-900 mb-6">
              Terms of Service
            </h1>
            <p className="text-lg text-gray-600">
              Last updated: January 2025
            </p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <div className="prose prose-lg max-w-none">
            
            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">1. Agreement to Terms</h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              These Terms of Service ("Terms") constitute a legally binding agreement between you and FluxByte Ltd ("Company," "we," "us," or "our") concerning your access to and use of our website and services. By accessing or using our services, you agree to be bound by these Terms. If you do not agree to these Terms, you must not access or use our services.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">2. Services Description</h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              FluxByte provides artificial intelligence solutions, machine learning services, AI automation, data intelligence, and related consulting services. We reserve the right to modify, suspend, or discontinue any aspect of our services at any time without prior notice.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">3. User Eligibility</h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              You must be at least 18 years old and have the legal capacity to enter into binding contracts to use our services. By using our services, you represent and warrant that you meet these eligibility requirements.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">4. User Accounts</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              When you create an account with us, you agree to:
            </p>
            <ul className="list-disc pl-6 mb-6 space-y-2 text-gray-700">
              <li>Provide accurate, current, and complete information</li>
              <li>Maintain and promptly update your account information</li>
              <li>Maintain the security of your account credentials</li>
              <li>Accept responsibility for all activities under your account</li>
              <li>Notify us immediately of any unauthorized access or security breach</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mb-6">
              We reserve the right to suspend or terminate accounts that violate these Terms or engage in fraudulent, abusive, or illegal activities.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">5. Acceptable Use Policy</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              You agree not to:
            </p>
            <ul className="list-disc pl-6 mb-6 space-y-2 text-gray-700">
              <li>Use our services for any illegal or unauthorized purpose</li>
              <li>Violate any laws, regulations, or third-party rights</li>
              <li>Transmit viruses, malware, or other harmful code</li>
              <li>Attempt to gain unauthorized access to our systems or networks</li>
              <li>Interfere with or disrupt the integrity or performance of our services</li>
              <li>Collect or harvest information about other users without consent</li>
              <li>Impersonate any person or entity or misrepresent your affiliation</li>
              <li>Use automated systems to access our services without permission</li>
              <li>Reverse engineer, decompile, or disassemble our software or services</li>
            </ul>

            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">6. Intellectual Property Rights</h2>
            
            <h3 className="text-2xl font-bold text-gray-900 mb-3 mt-6">6.1 Our Intellectual Property</h3>
            <p className="text-gray-700 leading-relaxed mb-6">
              All content, features, and functionality of our services, including but not limited to text, graphics, logos, icons, images, audio clips, software, and data compilations, are the exclusive property of FluxByte Ltd and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-3 mt-6">6.2 Your Content</h3>
            <p className="text-gray-700 leading-relaxed mb-6">
              You retain ownership of any content you submit to our services. By submitting content, you grant us a worldwide, non-exclusive, royalty-free license to use, reproduce, modify, adapt, publish, and distribute your content solely for the purpose of providing our services to you.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">7. Payment Terms</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              If you purchase services from us:
            </p>
            <ul className="list-disc pl-6 mb-6 space-y-2 text-gray-700">
              <li>You agree to pay all fees and charges according to the pricing and payment terms presented to you</li>
              <li>All fees are non-refundable unless otherwise stated in writing</li>
              <li>We reserve the right to change our pricing with 30 days' notice</li>
              <li>You are responsible for all taxes associated with your purchase</li>
              <li>Late payments may result in service suspension or termination</li>
            </ul>

            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">8. Confidentiality</h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              Both parties agree to maintain the confidentiality of any proprietary or confidential information disclosed during the course of our business relationship. This obligation survives the termination of these Terms.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">9. Data Protection and Privacy</h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              Your use of our services is also governed by our Privacy Policy. We are committed to protecting your personal data in accordance with applicable data protection laws, including GDPR and CCPA. Please review our Privacy Policy to understand how we collect, use, and protect your information.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">10. Disclaimers and Limitations of Liability</h2>
            
            <h3 className="text-2xl font-bold text-gray-900 mb-3 mt-6">10.1 Service Disclaimer</h3>
            <p className="text-gray-700 leading-relaxed mb-6">
              OUR SERVICES ARE PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. WE DO NOT WARRANT THAT OUR SERVICES WILL BE UNINTERRUPTED, ERROR-FREE, OR COMPLETELY SECURE.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-3 mt-6">10.2 Limitation of Liability</h3>
            <p className="text-gray-700 leading-relaxed mb-6">
              TO THE MAXIMUM EXTENT PERMITTED BY LAW, FLUXBYTE LTD SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, WHETHER INCURRED DIRECTLY OR INDIRECTLY, OR ANY LOSS OF DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES RESULTING FROM YOUR USE OF OUR SERVICES. OUR TOTAL LIABILITY SHALL NOT EXCEED THE AMOUNT YOU PAID US IN THE 12 MONTHS PRECEDING THE CLAIM.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">11. Indemnification</h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              You agree to indemnify, defend, and hold harmless FluxByte Ltd, its officers, directors, employees, agents, and affiliates from any claims, liabilities, damages, losses, costs, or expenses (including reasonable attorneys' fees) arising from your use of our services, violation of these Terms, or infringement of any third-party rights.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">12. Term and Termination</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              These Terms remain in effect until terminated by either party. We may terminate or suspend your access immediately, without prior notice, for any reason, including:
            </p>
            <ul className="list-disc pl-6 mb-6 space-y-2 text-gray-700">
              <li>Breach of these Terms</li>
              <li>Fraudulent, abusive, or illegal activity</li>
              <li>Non-payment of fees</li>
              <li>At our sole discretion for any other reason</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mb-6">
              Upon termination, your right to use our services will immediately cease. Provisions that by their nature should survive termination shall survive, including ownership provisions, warranty disclaimers, and limitations of liability.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">13. Dispute Resolution</h2>
            
            <h3 className="text-2xl font-bold text-gray-900 mb-3 mt-6">13.1 Governing Law</h3>
            <p className="text-gray-700 leading-relaxed mb-6">
              These Terms shall be governed by and construed in accordance with the laws of England and Wales, without regard to its conflict of law provisions.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-3 mt-6">13.2 Arbitration</h3>
            <p className="text-gray-700 leading-relaxed mb-6">
              Any dispute arising from these Terms shall be resolved through binding arbitration in accordance with the rules of the London Court of International Arbitration (LCIA), except where prohibited by law. The arbitration shall take place in London, United Kingdom.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">14. Changes to Terms</h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              We reserve the right to modify these Terms at any time. We will notify you of any material changes by posting the new Terms on our website and updating the "Last updated" date. Your continued use of our services after such changes constitutes your acceptance of the new Terms.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">15. Severability</h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              If any provision of these Terms is found to be unenforceable or invalid, that provision shall be limited or eliminated to the minimum extent necessary, and the remaining provisions shall remain in full force and effect.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">16. Entire Agreement</h2>
            <p className="text-gray-700 leading-relaxed mb-6">
              These Terms, together with our Privacy Policy and any other legal notices published by us, constitute the entire agreement between you and FluxByte Ltd concerning your use of our services.
            </p>

            <h2 className="text-3xl font-bold text-gray-900 mb-4 mt-8">17. Contact Information</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              If you have any questions about these Terms, please contact us:
            </p>
            <div className="bg-gray-50 p-6 rounded-lg mb-6">
              <p className="text-gray-700 mb-2"><strong>FluxByte Ltd</strong></p>
              <p className="text-gray-700 mb-2">Canal Road, Altrincham, WA14 1AE, United Kingdom</p>
              <p className="text-gray-700 mb-2">Email: <a href="mailto:legal@fluxbyte.ai" className="text-blue-600 hover:underline">legal@fluxbyte.ai</a></p>
              <p className="text-gray-700">Phone: <a href="tel:+441618837750" className="text-blue-600 hover:underline">0161 883 7750</a></p>
            </div>

            <div className="bg-blue-50 border-l-4 border-blue-600 p-6 rounded-lg mt-8">
              <p className="text-gray-700 leading-relaxed">
                <strong>Important:</strong> By using our services, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service. If you do not agree to these Terms, please do not use our services.
              </p>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
